<template>
  <v-card>
    <v-img
    alt="Nuestro Logo"
    class="shrink mr-2"
    contain
    src="../assets/logo2.png"
    transition="scale-transition"
    width="50"
    />  
        <!-- <v-toolbar-title text color="black">Sistema de Gestion de Residuos</v-toolbar-title> -->
    <h1>Sistema de Gestion de Residuos</h1>
  
    <v-tabs
    background-color="white"
    left
    dark>
    <v-tab ><a href="#">Inicio</a></v-tab>
    <v-tab ><a href="#Servicios">Servicios</a></v-tab>
    <v-tab><a href="#Noticias">Noticias</a></v-tab>
    <v-tab><a href="#Equipo">Nuestro Equipo</a></v-tab>
      
    </v-tabs>
    </v-card>
</template>

<script>
export default {

}
</script>

<style>

</style>

